import { h, render } from 'preact';
import BundlesApp from './components/App.js';

const renderBundlesApp = (element, props) => {
  render(<BundlesApp {...props} />, element);
};

export default renderBundlesApp;
